export function fmtLap(sec, precision = 2) {
  if (sec == null) return "—";
  const m = Math.floor(sec / 60);
  const s = (sec - m * 60).toFixed(precision).padStart(precision + 3, "0");
  return m > 0 ? `${m}:${s}` : s;
}

export function lapStats(data) {
  const valid = data.laps.filter((l) => l.valid);
  if (!valid.length) return { valid, best: null };
  const best = valid.reduce((a, l) => (l.time < a.time ? l : a));
  const nSec = data.sector_names.length;
  const bestSectors = Array.from({ length: nSec }, (_, i) => Math.min(...valid.map((l) => l.sectors[i])));
  const theoretical = nSec ? bestSectors.reduce((a, b) => a + b, 0) : null;
  const useful = valid.filter((l) => l.time <= best.time * 1.07);
  const avg = useful.reduce((a, l) => a + l.time, 0) / useful.length;
  const std = Math.sqrt(useful.reduce((a, l) => a + (l.time - avg) ** 2, 0) / useful.length);
  const maxes = Object.fromEntries(data.param_names.map((p) => {
    const vals = valid.map((l) => l.params[p]).filter((v) => v != null);
    return [p, vals.length ? Math.max(...vals) : null];
  }));
  return { valid, best, bestSectors, theoretical, useful, avg, std, maxes };
}

export function lapTag(data, index) {
  const l = data.laps[index];
  if (l.valid) return null;
  if (index === 0 || l.lap === 0) return "OUT";
  if (index === data.laps.length - 1) return "IN";
  return "X";
}
